"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.054 14.813c1.625 1.583 4.263 1.583 5.892 0L17 12.818l-2.054-1.995c-1.625-1.582-4.263-1.582-5.892 0L7 12.818l2.054 1.995zm1.28-1.995c0-.894.745-1.618 1.666-1.618.92 0 1.667.724 1.667 1.618 0 .895-.746 1.619-1.667 1.619-.92 0-1.667-.724-1.667-1.619z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6zm2 1h14v11H5V7z" })), "Preview");
//# sourceMappingURL=Preview.js.map